import React from 'react';
import { ArrowRightIcon, PhoneIcon } from 'lucide-react';
import { practice } from '../data/site';
import { Reveal } from './ui/Reveal';
export function EmergencySection() {
  return <section id="emergency" aria-labelledby="emergency-title" className="scroll-mt-24 bg-ink py-20 text-white lg:py-28" data-id="element-198" data-mp="30hmi4ef7nea3">
      <div className="mx-auto max-w-shell px-5 sm:px-8 lg:px-12" data-id="element-199" data-mp="2vi1fnu0u0nsm">
        <Reveal className="grid gap-10 lg:grid-cols-12 lg:items-end lg:gap-16" data-id="element-200" data-mp="2rhr3u0qcz35u">
          <div className="lg:col-span-7" data-id="element-201" data-mp="2mi4s5vq6huz5">
            <p className="eyebrow flex items-center gap-3 text-accent" data-id="element-202" data-mp="2mhbqva9znxoe">
              <span aria-hidden="true" className="h-px w-8 bg-accent" data-id="element-203" data-mp="2hiibtdf1zym4" />
              Dental emergency
            </p>
            <h2 id="emergency-title" className="font-display mt-6 text-[clamp(1.9rem,3.6vw,2.9rem)] leading-[1.08]" data-id="element-204" data-mp="2cl0bgbf3qrpq">
              Dental pain? Do not wait.
            </h2>
            <p className="mt-6 max-w-[56ch] text-[16.5px] leading-[1.8] text-white/65" data-id="element-205" data-mp="at3qkb71o5ia">
              If you have pain, a broken tooth, an infection or another urgent concern, call Lima
              Dental Group directly. Walk-ins are welcome, and we will let you know the next step
              clearly.
            </p>
          </div>

          <div className="flex flex-col gap-3 sm:flex-row lg:col-span-5 lg:justify-end" data-id="element-206" data-mp="38vn0t3yttpxd">
            <a href={practice.phoneHref} className="flex min-h-[54px] items-center justify-center gap-2.5 rounded-[10px] bg-white px-7 text-[15px] font-medium text-ink transition-all duration-300 hover:shadow-[0_0_0_3px_rgba(255,255,255,0.15)]" data-id="element-207" data-mp="38xg88lh9ke6f">
              <PhoneIcon aria-hidden="true" className="h-4 w-4" strokeWidth={1.75} data-id="element-208" data-mp="3mtbm2cwt2z2y" />
              Call now: {practice.phone}
            </a>
            <a href={practice.bookingUrl} target="_blank" rel="noreferrer" className="group flex min-h-[54px] items-center justify-center gap-2.5 rounded-[10px] border border-white/25 px-7 text-[15px] font-medium text-white transition-colors hover:border-white/60" data-id="element-209" data-mp="je5rw6frdg9s">
              Book appointment
              <span className="hover-arrow" data-id="element-210" data-mp="t0gu9l9y63wx">
                <ArrowRightIcon aria-hidden="true" className="h-4 w-4" strokeWidth={1.75} data-id="element-211" data-mp="ozwue9xzom73" />
              </span>
            </a>
          </div>
        </Reveal>
      </div>
    </section>;
}